if (!customElements.get('gcs-wood-guide')) {
  customElements.define('gcs-wood-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-veneer-crop]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof this.dialog.showModal !== 'function') return;
        const crop = link.dataset.veneerCrop.split(' ').map(Number);
        if (crop.length !== 4 || crop.some(n => !Number.isFinite(n)) || crop[2] <= 0 || crop[3] <= 0) return;
        event.preventDefault();
        this.opener = link;
        this.dialog.querySelector('h3').textContent = link.dataset.veneerName;
        const detail = this.dialog.querySelector('svg');
        detail.setAttribute('viewBox', crop.join(' '));
        detail.style.aspectRatio = `${crop[2]} / ${crop[3]}`;
        detail.style.maxWidth = `calc(65vh * ${crop[2] / crop[3]})`;
        detail.querySelector('image').setAttribute('href', link.href);
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }, options);
      this.dialog.querySelector('button').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'Tab') {
          event.preventDefault();
          this.dialog.querySelector('button').focus();
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        this.opener?.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow ?? '';
      }
      this.controller?.abort();
      this.controller = null;
    }
  });
}
